export enum UserFreeShippingStatuses {
  active = 'active',
  disabled = 'disabled',
  expired = 'expired',
}

export enum FreeShippingCodesStatuses {
  valid = 'valid',
  invalid = 'invalid',
  used = 'used',
  expired = 'expired',
}
